import {
  ADD_RELATION,
  ADD_RELATION_FAILURE,
  ADD_RELATION_SUCCESS,
  EDIT_RELATION,
  EDIT_RELATION_FAILURE,
  EDIT_RELATION_SUCCESS,
} from '../Actiontype';

const initialState = {
  AddorEdituserSuccess: false,
  AddorEdituserSuccessMessage: '',
  AddorEdituserFailure: false,
  AddorEdituserFailureMessage: '',
  UserDetails: null,
};
export default function RelationReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_RELATION:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case ADD_RELATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case ADD_RELATION_FAILURE:
      console.log(action.payload, 'mmmmmmm');
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    case EDIT_RELATION:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case EDIT_RELATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.message,
      };
    case EDIT_RELATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.message,
      };
    default:
      return {
        ...state,
      };
  }
}
